import renderText from "./renderText";
import renderDivider from "./renderDivider";
import CirclePercentage from "../../CirclePercentage";
export default function ValuePercentage(params) {
  var _params$otherFields, _params$otherFields2;
  const value = params.value;
  const percentage = params.data[(_params$otherFields = params.otherFields) === null || _params$otherFields === void 0 ? void 0 : _params$otherFields.percentage];
  const valueString = params.data[(_params$otherFields2 = params.otherFields) === null || _params$otherFields2 === void 0 ? void 0 : _params$otherFields2.valueString];
  if (isNaN(parseInt(value, 10)) || isNaN(parseInt(percentage, 10))) return null;
  const valuePercentageCell = document.createElement('div');
  valuePercentageCell.classList.add('w5-value-percentage-cell');
  const text = renderText(value, valueString);
  const divider = renderDivider();
  const circle = CirclePercentage(percentage, params);
  if (!text || !circle) return null;
  valuePercentageCell.appendChild(text);
  valuePercentageCell.appendChild(divider);
  valuePercentageCell.appendChild(circle);
  return valuePercentageCell;
}